import React, { useMemo } from 'react';
import { theme } from '@/assets/theme';
import { ThemeProvider } from 'styled-components/native';
import { useScreenSize } from '@/hooks/use.screen.size';

function BaseThemeProvider({ children }) {
  const { width, height } = useScreenSize(); // causes re render when dimensions change

  const themeProxy = useMemo(() => {
    return { ...theme };
  }, [width, height]);

  return <ThemeProvider theme={themeProxy}>{children}</ThemeProvider>;
}

export const AppThemeProvider = React.memo(BaseThemeProvider);
